import type { schema } from "@editor/schema";

const playSVG = `<svg viewBox="0 0 640 360" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M396.5 189.026L289.25 250.947C281.917 255.181 272.75 249.889 272.75 241.421L272.75 117.579C272.75 109.111 281.917 103.819 289.25 108.053L396.5 169.974C403.833 174.208 403.833 184.792 396.5 189.026Z" fill="white" fill-opacity="0.8" stroke="#707070" stroke-width="6"/></svg>`;

export function externalImage(url: string) {
  return "/external_image?url=" + url;
}

export const Base64PlaySVGImageData = `data:image/svg+xml;base64,${
  import.meta.env.SSR ? Buffer.from(playSVG, "utf-8").toString("base64") : btoa(playSVG)
}`;
